/**
 * @generated SignedSource<<81f75deeec6a3769a4bdff5aaf443cd5>>
 * @relayHash 6d43cdcde683ec3e0605a8b337324697
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f42c74c83bf4f7dfa18d707903ff8b49525e303e6c43e8d5fc8c682707cbb799

import type { ConcreteRequest } from 'relay-runtime';
export type ConvoAiHomeThreadsInput = {
  promptOverride?: string | null;
  skipCache?: boolean | null;
  userId?: string | null;
};
export type RecommendedSpacesPanelQuery$variables = {
  cloudId: string;
  experience: string;
  homeThreadsInput: ConvoAiHomeThreadsInput;
};
export type RecommendedSpacesPanelQuery$data = {
  readonly convoai_homeThreads: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string | null;
        readonly sources: ReadonlyArray<{
          readonly __typename: "ConvoAiHomeThreadsFirstPartySource";
          readonly ari: string;
          readonly data: {
            readonly __typename: string;
          } | null;
          readonly url: string;
        } | {
          readonly __typename: "ConvoAiHomeThreadsThirdPartySource";
          readonly url: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null> | null;
        readonly title: string | null;
      } | null;
    }> | null;
  } | null;
};
export type RecommendedSpacesPanelQuery = {
  response: RecommendedSpacesPanelQuery$data;
  variables: RecommendedSpacesPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "experience"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "homeThreadsInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "homeThreadsInput",
    "variableName": "homeThreadsInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "ari"
},
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/)
  ],
  "type": "ConvoAiHomeThreadsThirdPartySource"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RecommendedSpacesPanelQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConvoAiHomeThreadsResult",
        "kind": "LinkedField",
        "name": "convoai_homeThreads",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConvoAiHomeThreadsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConvoAiHomeThread",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "sources",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/)
                            ]
                          }
                        ],
                        "type": "ConvoAiHomeThreadsFirstPartySource"
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecommendedSpacesPanelQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConvoAiHomeThreadsResult",
        "kind": "LinkedField",
        "name": "convoai_homeThreads",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConvoAiHomeThreadsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConvoAiHomeThread",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "sources",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v2/*: any*/)
                                ],
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ]
                          }
                        ],
                        "type": "ConvoAiHomeThreadsFirstPartySource"
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f42c74c83bf4f7dfa18d707903ff8b49525e303e6c43e8d5fc8c682707cbb799",
    "metadata": {},
    "name": "RecommendedSpacesPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ec44e6d020cdac85dbdc2e6743d6b65f";

export default node;
